import { ReactElement } from 'react';

const ScientificArticles = (): ReactElement => {
  const AlternativeSlagFluidizers = `${process.env.PUBLIC_URL}/articles/2023-FALSETTI-et-al-Effects-alternative-slag-fluidizers-secondary-steelmaking.pdf`;
  const SlagModellingIntegratedSteelMill = `${process.env.PUBLIC_URL}/articles/2016-LOPEZ-et-al-Slag-Modeling-Ladle-Life-Integrated-Steel-Mill.pdf`;
  const ModellingLadleSlagsAndIntegration = `${process.env.PUBLIC_URL}/articles/2023-LOPEZ-et-al-Modeling-Ladle-Slags-Integration-Supervisory-System.pdf`;

  return (
    <section id="section-scientific-articles" className="landing-page-sections section-past">
      <div className="grid-container">
        <div className="grid-x justify-center">
          <div className="large-8 cell section-head mg-bottom-2 center">
            <h2>Scientific Articles</h2>
            <p>
              <b>...</b>
            </p>
          </div>
        </div>
      </div>

      <div className="sec-module modulenum-1 bg-wrapper full mod-icon-box-grid">
        <div className="grid-container">
          <div className="grid-x grid-margin-x grid-margin-y justify-center">
            <div className="large-3 medium-6 cell center icon-box-grid-cell">
              <div className="content">
                <h4>Assessing the effects of using alternative slag fluidizers in secondary steelmaking</h4>
              </div>
              <div className="mg-top-1">
                <a className="more-link" href={AlternativeSlagFluidizers} target="_blank" rel="noreferrer noopener">
                  read more
                </a>
              </div>
            </div>
            <div className="large-3 medium-6 cell center icon-box-grid-cell">
              <div className="content">
                <h4>
                  Modeling ladle slags using a mass balance approach and integration into the ladle furnace process
                  supervisory system
                </h4>
              </div>
              <div className="mg-top-1">
                <a className="more-link" href={ModellingLadleSlagsAndIntegration} target="_blank" rel="noreferrer noopener">
                  read more
                </a>
              </div>
            </div>
            <div className="large-3 medium-6 cell center icon-box-grid-cell">
              <div className="content">
                <h4>Slag Modeling for Increasing Ladle Life at Integrated Steel Mill - Brazil</h4>
              </div>
              <div className="mg-top-1">
                <a className="more-link" href={SlagModellingIntegratedSteelMill} target="_blank" rel="noreferrer noopener">
                  read more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScientificArticles;
